<template>
    <div class="table">
        <!-- 对象表格 -->
        <table v-if="tableStatus === 0">
            <table>
                <tr>
                    <td colspan="2" class="name">
                        <slot name="headTitle"></slot>
                    </td>
                </tr>
                <tr v-for="(item, index) in tableObjTitle" :key="index">
                    <td><span v-if="item.tableLeft">{{ item.tableLeft }}：{{ tableObjData[item.dataSource] }}</span></td>
                    <td><span v-if="item.tableRight">{{ item.tableRight }}：{{ tableObjData[item.innerDataSource]
                            }}</span></td>
                </tr>
            </table>
        </table>
        <!-- 数组表格 -->
        <div v-if="tableStatus === 1">
            <table>
                <thead>
                    <th class="name" v-for="item in tableArrayTitle" :key="item.title">{{ item.title }}</th>
                </thead>

                <tbody
                    :style="tableStyle.screenHeight === 1080 && tableStyle.isStyle ?
            { display: 'block', height: tableStyle.personnel ? '500px' : '200px', overflow: 'hidden', overflowY: 'auto', }
            : tableStyle.screenHeight !== 1080 && !tableStyle.isStyle ? {} :
                { display: 'block', height: tableStyle.personnel ? '350px' : '140px', overflow: 'hidden', overflowY: 'auto', }">

                    <tr v-for="( item, index ) in  tableArrayData " :key="index">
                        <td v-for=" ele  in  tableArrayTitle " :key="ele.title">
                            {{ tableArrayData[index][ele.dataSource] }}
                            <a class="table_action" v-if="ele.title == '操作' && item.type===1" :href="item.fileUrl">下载变更信息表</a>
                          <a class="table_action" v-if="ele.title == '操作' && item.type===2" @click="openChangeContentModal(item)" >查看变更信息</a>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
  <!-- 变更内容弹框 -->
  <ChangeContentModal
      v-model:visible="changeContentModalVisible"
      :currentRecord="currentChangeRecord"
      @cancel="handleChangeContentModalCancel"
  />
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, watch, onMounted, defineProps } from 'vue'
import ChangeContentModal from '@/views/car/components/plateChangeContentModal.vue';

const props = defineProps({
    tableStatus: {
        type: Number,
        default: 0, // 判断表格为 对象 形式的数据 还是 数组 形式的数据
    },
    // 对象形式
    tableObjTitle: {
        type: Array,
        default: () => {
            return [
                {
                    tableLeft: '创建人',
                    tableRight: '更新人',
                    dataSource: 'creator',  // 数据指向 tableObjData 中的 creator
                    innerDataSource: 'regenerator'  // 数据指向 tableObjData 的 regenerator
                },
            ]
        }
    },
    tableObjData: {
        type: Object,
        default: () => {
            return {
                creator: '王XX',
                regenerator: '刘XX',
            }
        }
    },

    // 数组形式
    tableStyle: {
        type: Object,
        default: () => {
            return {
                screenHeight: 0,
                isStyle: true
            }
        }
    },
    tableArrayTitle: {
        type: Array,
        default: () => {
            return [
                {
                    title: '序号',
                    dataSource: 'ranking'  //  // 数据指向 tableArrayData 中的 ranking
                }
            ]
        }
    },
    tableArrayData: {
        type: Array,
        default: () => {
            return [
                {
                    ranking: '01',
                }
            ]
        }
    }

})

const changeContentModalVisible = ref(false);
const currentChangeRecord = ref(null);

const openChangeContentModal = (record) => {
  currentChangeRecord.value = record;
  changeContentModalVisible.value = true;
};

const handleChangeContentModalCancel = () => {
  changeContentModalVisible.value = false;
  currentChangeRecord.value = null;
};

const action = record => {
    console.log(record);
}

onMounted(() => {

})

</script>
<style lang="less" scoped>
.table {
    width: 870px;
    margin: 0 auto;

    table {
        width: 100%;

        td {
            border: 1px solid #E1E7EF;
            padding: 14px 0 11px 28px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #636D7B;
            text-align: left;
        }

        .name {
            background: #F6F8FA;
            padding: 14px 0 11px 28px;
            text-align: left;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            color: #1D2129;
        }

        .table_action {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #186FF2;
        }
    }
}


// `tbody{ display:block }`

// 此时可以给tbody设置height/max-height/overflow-auto

// 此时表格会变形，因此设置：
thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

// 当设置滚动条，tbody与thead宽度不一致，若需宽度一致须减去滚动条的宽度：
thead {
    // width: calc(100% - 1em)
}
</style>
